/* Don Juan Pomade V7 — Homepage carousel focus hygiene.
 * Accessibility-only: no layout, resource prioritization or carousel navigation changes.
 * Non-visible slides can remain pointer-clickable (Ritual "with hints" mode).
 */
(() => {
  'use strict';
  const focusable = 'a[href], area[href], button, input, select, textarea, [tabindex], [contenteditable="true"]';
  const saved = new WeakMap();

  function syncSlide(slide) {
    const hidden = slide.getAttribute('aria-hidden') === 'true';
    for (const child of slide.querySelectorAll(focusable)) {
      if (hidden) {
        if (!saved.has(child)) saved.set(child, child.getAttribute('tabindex'));
        if (child.getAttribute('tabindex') !== '-1') child.setAttribute('tabindex', '-1');
      } else if (saved.has(child)) {
        const original = saved.get(child);
        if (original === null) child.removeAttribute('tabindex');
        else child.setAttribute('tabindex', original);
        saved.delete(child);
      }
    }
  }

  const observers = new WeakMap();
  function attach(carousel) {
    if (observers.has(carousel)) return;
    const sync = () => carousel.querySelectorAll('slideshow-slide[aria-hidden]').forEach(syncSlide);
    sync();
    if (typeof MutationObserver !== 'function') return;
    // Synchronize only slides that actually changed. Preserve behavior for
    // dynamically injected controls and Shopify section updates.
    const observer = new MutationObserver((records) => {
      const affected = new Set();
      for (const record of records) {
        if (record.type === 'attributes') {
          if (record.target.localName === 'slideshow-slide') affected.add(record.target);
          continue;
        }
        const parentSlide = record.target.closest?.('slideshow-slide');
        if (parentSlide) affected.add(parentSlide);
        for (const node of record.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.localName === 'slideshow-slide') affected.add(node);
          node.querySelectorAll?.('slideshow-slide[aria-hidden]').forEach((slide) => affected.add(slide));
        }
      }
      affected.forEach(syncSlide);
    });
    observer.observe(carousel, {subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden']});
    observers.set(carousel, observer);
  }
  function scan() {
    document.querySelectorAll('slideshow-component').forEach(attach);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once: true});
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
